import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Card, Spinner, Button, Table, Col, Row, Alert } from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlus, FaEye, FaArrowLeft } from 'react-icons/fa';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getAllSubProduct, subproductDeletion } from "./subproductAction";
import $ from 'jquery';
import moment from 'moment'
import Tooltip from '@mui/material/Tooltip';
import Swal from 'sweetalert2';
import { getSRolePermission } from '../userRolePermission/rolepermissionAction';
import {getSingleProductRate} from "../rates/ratesAction";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Button1 from '@mui/material/Button';

const SubProductList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { name } = useParams();
    const firstUpdate = useRef(true);
    const { subproducts, pisLoading, pdstatus, pdmessage } = useSelector((state) => state.subproductList);
    const [isAlive,setIsAlive] = useState(true);
    const { baseid,apmessage ,rmessage} = useSelector((state) => state.productratesList);

    const approvalList  = useSelector((state) => state.productratesList?.rates?.approvalList || []);
  
    console.log("approvalList",approvalList);
    
   
    useEffect(() => {
        dispatch(getSRolePermission());
        dispatch(getSingleProductRate(0));

        
    }, []);
  
    const { permissionisLoading, combinedrolepermissiondetails } = useSelector(
        (state) => state.rolePermissionList
      );

      const filteredPermissions = combinedrolepermissiondetails.filter(
        (item) => item.label === "Add Sub Product"
      );
      
      let menu_add = 0;
      let menu_edit = 0;
      let menu_delete = 0;
      
      if (filteredPermissions.length > 0) {
        const permission = filteredPermissions[0];
        menu_add = permission.menu_add;
        menu_edit = permission.menu_edit;
        menu_delete = permission.menu_delete;
      }
      const onPagepath = () => {
        navigate('/createSubProduct');
    }

    useLayoutEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            dispatch(getAllSubProduct());
            return () => setIsAlive(false);
        }

        // console.log("componentDidUpdateFunction");
    },[isAlive]);
    useEffect(() => {
        dispatch(getAllSubProduct());
        return () => setIsAlive(false);
    }, [isAlive]);

    if (pisLoading) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl justify-content-center">
                    <h2>Loading.....</h2>
                    {pisLoading && <Spinner variant='info' center="true" animation='border' />}

                </Container>
            </>
        );
    }
console.log(subproducts.length);
    if (subproducts.length === 0) {
        return (
            <>
                
            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"  style={{fontFamily:'Times New Roman',fontWeight:'600' }}>Sub Product List</h3>
                        {menu_add===1 &&(<Button1 variant="contained" onClick={onPagepath} color="success" style={{ width: '', float: '', backgroundColor: '#d1af2b', fontSize: '10px'}} startIcon={<AddCircleOutlineIcon />}>
                            Add Sub Product
                        </Button1>)}
                    </div>
                    <div className="card-body">
                        <Row>
                        <Link to="/"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
              
                                <p style={{textAlign:'center'}}>No Data Available.</p>
                          
                    </div>
                </div>
            </div>
            </>
        );
    }

if(name){

    
    if (approvalList.length === 0) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl">

                </Container>
                <Container className="my-4 mx-4 container-xl">
                    
                    <table id="example" className="table table-hover table-bordered display" style={{ "width": "100%", marginLeft: '130px', marginRight: '-100px'  }}>
                        <thead>
                            <tr>
                                <th style={{backgroundColor:'rgb(0 0 0 / 3%)',padding:'10px'}}><Link to="/" style={{ marginLeft: '0px', marginRight: '-100px' }}><span className="badge bg-success" style={{ backgroundColor: 'rgb(156 186 237)', color: 'white' }}><FaArrowLeft />&nbsp;Go Back</span></Link><h4>Approval Product Rate List</h4></th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{textAlign:'center'}}>No Data Available.</td>
                               
                            </tr>


                        </tbody>
                    </table>




                    <br />

                    {/* <Link to="/" style={{ marginLeft: '130px', marginRight: '-100px' }}><span className="badge bg-success" style={{ backgroundColor: 'rgb(156 186 237)', color: 'white' }}><FaArrowLeft />&nbsp;Go Back</span></Link>  <h2 style={{ marginLeft: '130px', marginRight: '-100px' }}>No Approval Data to display.....</h2> */}

                </Container>
            </>
        );
    }



}

    const renderedSubProduct = subproducts.map((subproduct,index) => (
        
        <tr key={subproduct.id}>
            <td>{index + 1}</td>

            <td>{subproduct.product_name}</td>
              
            <td>{subproduct.status == 1 ? <span className="badge bg-success"> Enable</span> : <span className="badge bg-danger"> Disable</span>}</td>
            
            <td className="tdstyle" style={{width:"111px"}}><><Tooltip title="View Sub Products"><Button className="btn btn-sm btn-primary"  onClick={(e) => onSubProductSingle(subproduct.product_id,subproduct.product_name,e)}  id={subproduct.product_id} ><FaEye className='fwcolor' /></Button></Tooltip>  </></td>
            
        </tr>
    ))

    const renderedSubProduct2 = approvalList.filter(obj => obj.status == "Pending").map((subproduct,index) => (
        
        <tr >
            <td>{index + 1}</td>

            <td>{subproduct.product_name}</td>
              
            {!name && (<td>{subproduct.status == 1 ? <span className="badge bg-success"> Enable</span> : <span className="badge bg-danger"> Disable</span>}</td>)}
          <td className="tdstyle" style={{width:"111px"}}><><Tooltip title="View Sub Products"><Button className="btn btn-sm btn-primary"  onClick={(e) => onSubProductSingle2(subproduct.pro_id,subproduct.product_name,e)}  id={subproduct.pro_id} ><FaEye className='fwcolor' /></Button></Tooltip>  </></td>
            
        </tr>
    ))


    
    const onSubProductDelete = (id, e) => {
        e.preventDefault();
        Swal.fire({
            title: 'Are you sure want to delete the sub product?',
            showDenyButton: true,
            icon:'error',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
              actions: 'my-actions',
              cancelButton: 'order-1 right-gap',
              confirmButton: 'order-2',
              denyButton: 'order-3',
            }
          }).then((result) => {
            if (result.isConfirmed) {
                dispatch(subproductDeletion(id));
                dispatch(getAllSubProduct());
                navigate('/subproductList');
                getAllSubProduct();
                setIsAlive(true)
                  
              Swal.fire('Sub Product Deleted Successfully!', '', 'success')
            } else if (result.isDenied) {
              Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
            }
          })
 

    }

    const onSubProductModify = (id, e) => {
        e.preventDefault();
       //console.log('select role '+id);
       navigate('/modifySubProduct/' + id); 
   }

   const onSubProductSingle = (id, name,  e) => {
    e.preventDefault();
   //console.log('select role '+id);
   navigate('/subproductListId/' + id +"/"+ name); 
}
 

const onSubProductSingle2 = (id, name,  e) => {
    e.preventDefault();
   //console.log('select role '+id);
   navigate('/subproductListId/' + id +"/"+ name + "/" + "approval"); 
}


    //initialize datatable
    $(document).ready(function () {
        setTimeout(function () {
            if ($.fn.dataTable.isDataTable('#example')) {
                const table = $('#example').DataTable();
            }
            else {
                const table = $('#example').DataTable({
                    paging: true,
                    pagingType: 'full_numbers',
                    pageLength: 5,
                    processing: true,
                    dom: 'Bfrtip',
                    buttons: ['csv', 'print'],
                    // buttons: ['copy', 'csv', 'print'],
                    destroy: true,

                });
            }

        },
            1000
        );
    });
    return (
        <>

            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2" style={{fontFamily:'Times New Roman', fontWeight:'600' }}>Select Your Product</h3>
                        {/* {menu_add===1 && !name ? <div style={{ display: 'flex', justifyContent: 'flex-start' }}><Link className="btn alink btncolorb" variant="btncolorb" to="/createSubProduct"><FaPlus className='fwcolor' /> Add Sub Product</Link>{' '}</div>:''} */}
                        {menu_add===1 && !name ?  <Button1 variant="contained" onClick={onPagepath} color="success" style={{ width: '', float: '', backgroundColor: '#d1af2b', fontSize: '10px'}} startIcon={<AddCircleOutlineIcon />}>
                            Add Sub Product
                        </Button1>:''}
                    </div>
                    <div className="card-body">
                        <Row>
                        <Link to="/"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 

                        </Row>
                        <br />
                      {name ?    <table id="example" className="table table-hover table-bordered display" style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                             {/* <th>Image</th> */}
                                            <th>Product Name</th>
                                            {/* <th>Sub Product Name</th> */}
                                           {!name && (<th>Status</th>)} 
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderedSubProduct2}


                                    </tbody>
                                </table>: <table id="example" className="table table-hover table-bordered display" style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                             {/* <th>Image</th> */}
                                            <th>Product Name</th>
                                            {/* <th>Sub Product Name</th> */}
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderedSubProduct}


                                    </tbody>
                                </table>}
                               
                           

                    </div>
                </div>
            </div>

        </>
    )
}

export default SubProductList
